module.exports = __webpack_public_path__ + "static/media/Cristo-que-vigila-el-pueblo-Cerro-Verde-y-la-planta-de-bombeo-de-la-minera.13509ad2.jpg";